import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RoomReportResponseV4Schema } from "../response/RoomReportResponseV4";

const API_VERSION = 'v4'; // Menggunakan v4

interface FilterProps {
    property_id: string;
    base_on: string;
    start_date: string;
    end_date: string;
}

interface RoomReportV4Props {
    filter?: FilterProps;
    orderBy?: string;
    sort?: 'asc' | 'desc';
    type: string | null;
}

const useRoomReportV4 = (params: RoomReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-room', // Query key unik untuk room report
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.orderBy,
            params.sort,
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-room`, {
                    filter: params.filter,
                    orderBy: params.orderBy,
                    sort: params.sort,
                });

                const validationResult = RoomReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Room report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Room report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && params.type === "room_report",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useRoomReportV4;